var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.deviceDataList,
            height: "100%",
            "header-row-style": _vm.getRowClass,
            "row-style": _vm.tableRowStyle,
            "header-cell-style": _vm.tableHeaderColor
          }
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "属性名称" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "val", label: "采集数据" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-113a3c94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113a3c94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/table_devdata_list.vue
// module id = null
// module chunks = 